import { CaseModel } from "@ortho-next/nextray-core";
import { Vector2 } from "three";
import { bindedModel } from "../Models/BindedModel";
import { ViewPlanImages, ViewPlanUtils } from "../Utils/ViewPlanUtils";
import { Main } from "./Main";

export async function getViewPlanImages(caseModel: CaseModel, resolution: Vector2): Promise<ViewPlanImages> {
    const tempDiv: HTMLDivElement = document.createElement('div');
    document.body.appendChild(tempDiv); // to fix canvas style calculations

    const main = new Main(tempDiv);
    await loadScene(main, caseModel);

    forceLayers();

    const viewPlanUtils = new ViewPlanUtils(main, main['_context']);
    const result = viewPlanUtils.generateImages(main.model.stateType, resolution);

    tempDiv.remove();

    return result;
}

async function loadScene(main: Main, caseModel: CaseModel): Promise<void> {
    await main.loadScenes(caseModel);

    let isPlateLoadedAP = !main.hasAP || !bindedModel.isPlateInserted;
    let isPlateLoadedLT = !main.hasLT || !bindedModel.isPlateInserted;

    return new Promise((resolve) => {
        if (isPlateLoadedAP && isPlateLoadedLT) resolve();

        main.bridge.addEventListener("onResult", (e) => {
            isPlateLoadedAP ||= e.args === 'plateLoadedAP';
            isPlateLoadedLT ||= e.args === 'plateLoadedLT';

            if (isPlateLoadedAP && isPlateLoadedLT) resolve();
        });
    });
}

function forceLayers(): void {
    bindedModel.layer_lines = false;
    bindedModel.layer_goniometers = false;
    bindedModel.layer_labels = true;
    bindedModel.layer_plate = true;
    bindedModel.layer_osteotomy = true;
    bindedModel.layer_mechAxis_weightBearing = true;
    bindedModel.layer_mechAxis_mechanical = true;
    bindedModel.layer_mechAxis_anatomical = true;
    bindedModel.layer_contralateral_all = true;
}
